import { action } from 'typesafe-actions';
import { CriarAtendimentoTypes, Notas, Filter, Pagination, FiltroNotas } from './types';

export const loadRequestNotas = (
  filtro: FiltroNotas | any,
  codParc: number,
  pagination?: Pagination
) =>
  action(CriarAtendimentoTypes.LOAD_REQUEST, {
    filtro,
    codParc,
    pagination,
  });

export const loadSuccessNotas = (notas: Notas[], pagination: Pagination) =>
  action(CriarAtendimentoTypes.LOAD_SUCCESS, { notas, pagination });

export const loadFailureNotas = () => action(CriarAtendimentoTypes.LOAD_FAILURE, {});

export const filterNotas = (filter: Filter) =>
  action(CriarAtendimentoTypes.FILTER_NOTAS, { filter });

export const cleanStateNotas = () => action(CriarAtendimentoTypes.CLEAN_NOTAS);
